// List the object paths in the state you would like to be hydrated between sessions
import {flattenDeep, get} from 'lodash'
import {SKILLS} from 'helpers/onboarding'
import {contactsContextQuotesTabPivotTableKey} from 'reducers/contactsContext/selected/quotesTab'
import {contactsContextDocumentsTabPivotTableKey} from 'reducers/contactsContext/selected/documentsTab'
import {contactsContextOpportunitiesTabPivotTableKey} from 'reducers/contactsContext/selected/opportunitiesTab'
import {contactsContextsInvoicesTabPivotTableKey} from 'reducers/contactsContext/selected/invoicesTab'
import {contactsContextActivitiesTabPivotTableKey} from 'reducers/contactsContext/selected/activitiesTab'
import {
  viewCompanyActivitiesPivotTableKey,
  viewCompanyInvoicesPivotTableKey,
  viewCompanyQuotesPivotTableKey,
} from 'reducers/dialogs/viewCompanyDialog'
import {
  quotingContextSelectorOrderItemsPivotTableKey,
  quotingContextSelectorOrdersPivotTableKey,
} from 'reducers/quotingContext/selector'
import {quotingContextQuotePivotTableKey} from 'reducers/quotingContext/quotes'
import {deliveredNotInvoicedPivotTableKey} from 'reducers/invoicingContext/notInvoiced'
import {activitiesTabPivotTableKey} from 'reducers/quotingContext/selected/activitiesTab'
import {invoicesTabPivotTableKey} from 'reducers/quotingContext/selected/invoicesTab'
import {readyForDeliveryQuotesPivotTableKey} from 'reducers/deliveriesContext/readyForDelivery'
import {deliveryNotesPivotTableKey} from 'reducers/deliveriesContext/deliveryNotes'
import {invoicingContextInvoicesPivotTableKey} from 'reducers/invoicingContext/invoices'
import {invoiceItemsPivotTableKey} from 'reducers/invoicingContext/selected'
import {partsPivotTableKey} from 'reducers/priceListsContext/parts'
import {contactsContextGridPivotTableKey} from 'reducers/contactsContext/grid'
import {purchaseOrdersPivotTableKey} from 'reducers/purchasingContext/purchaseOrders'
import {
  purchasingContextSelectorOrderItemsPivotTableKey,
  purchasingContextSelectorOrdersPivotTableKey,
} from 'reducers/purchasingContext/selector'
import {purchaseOrderItemsPivotTableKey} from 'reducers/purchasingContext/selected'
import {
  itemPivotTableKey,
  quotingContextBillOfLabourPivotTableKey,
  quotingContextBillOfMaterialsPivotTableKey,
} from 'reducers/quotingContext/selected'
import {invoicingContextReceivedNotInvoicedPivotTableKey} from 'reducers/invoicingContext/receivedNotInvoiced'
import {purchasingContextPurchaseInvoiceItemsPivotTableKey} from 'reducers/purchasingContext/selectedPurchaseInvoice'
import {diaryContextActivitiesPivotTable} from 'reducers/diaryContext/activities'
import {quotingContextDocumentsPivotTableKey} from 'reducers/quotingContext/selected/documents'
import {quotingContextApprovalsPivotTableKey} from "reducers/quotingContext/approvals"
import {quotingContextQuoteApprovalsPivotTableKey} from 'reducers/quotingContext/selected/approvals'
import {listBuilderContactsPivotTableKey} from 'reducers/contactsContext/listBuilder'
import {salesContextOpportunitiesPivotTableKey} from 'reducers/salesContext/opportunitiesView'
import {
  opportunityDialogActivitiesPivotTableKey,
  opportunityDialogQuotesPivotTableKey,
} from 'reducers/dialogs/opportunityDialog'
import {
  addItemsToPurchaseOrderDialogChosenItemsPivotTableKey,
  addItemsToPurchaseOrderDialogItemsPivotTableKey,
  addItemsToPurchaseOrderDialogOrdersPivotTableKey,
} from 'reducers/dialogs/addItemsToPurchaseOrderDialog'
import {contactsSearchPivotTableKey} from 'reducers/contactsContext/search'
import {contactsContextCompanyContactsPivotTableKey} from 'reducers/contactsContext/selected/companyContacts'
import {deliveriesQuoteSelectorPivotTableKey} from "reducers/deliveriesContext/quoteSelector"
import {jobCardOrderItemsPivotTableKey} from "reducers/dialogs/viewJobCardDialog"
import {jobCardListViewPivotTableKey} from "reducers/productionContext/jobBoards/jobCardListView"

// register any locations you want saved in totality
const staticLocations = [
  'contactsContext.search.selectedList',
  'contactsContext.search.mode',
  'contactsContext.search.filters',
  'contactsContext.search.searched',
  'contactsContext.openCompanies',
  'contactsContext.contactFields',
  'contactsContext.companyFields',
  'contactsContext.individualFields',
  'contactsContext.selectedContactFields',
  'contactsContext.selectedCompanyFields',
  'contactsContext.selectedIndividualFields',
  'contactsContext.fieldSelectMode',
  'contactsContext.contactLists.showingHiddenLists',
  'contactsContext.contactLists.selectedCategoryId',
  'contactsContext.contactLists.expandedCategories',
  'contactsContext.selected.isContactDetailsVisible',
  'contactsContext.selected.activitiesTab.showCompleted',
  'contactsContext.selected.activitiesTab.showRejected',
  'contactsContext.selected.activitiesTab.showAllContacts',
  'contactsContext.selected.opportunitiesTab.showClosed',
  'contactsContext.selected.opportunitiesTab.showAllContacts',
  'contactsContext.selected.companyContacts.showDormants',
  'deliveriesContext.readyForDelivery.timeKey',
  'deliveriesContext.readyForDelivery.targetStart',
  'deliveriesContext.readyForDelivery.targetEnd',
  'deliveriesContext.readyForDelivery.jobStatus',
  'deliveriesContext.readyForDelivery.jobBoard',
  'deliveriesContext.deliveryNotes.scheduledDateTimeKey',
  'deliveriesContext.deliveryNotes.scheduledDateTargetStart',
  'deliveriesContext.deliveryNotes.scheduledDateTargetEnd',
  'deliveriesContext.deliveryNotes.deliveredDateTimeKey',
  'deliveriesContext.deliveryNotes.deliveredDateTargetStart',
  'deliveriesContext.deliveryNotes.deliveredDateTargetEnd',
  'deliveriesContext.deliveryNotes.status',
  'deliveriesContext.deliveryNotes.jobStatus',
  'deliveriesContext.deliveryNotes.printedEmailed',
  'deliveriesContext.deliveryNotes.method',
  'deliveriesContext.deliveryNotes.returnReason',
  'deliveriesContext.deliveries.calendarFieldOrder',
  'deliveriesContext.deliveries.calendarSelectedFields',
  'deliveriesContext.deliveries.filters',
  'deliveriesContext.quoteSelector.includeFullyScheduled',
  'deliveriesContext.quoteSelector.includeFullyDelivered',
  'departmentContext.departments',
  'departmentContext.workCentres',
  'dialogs.viewCompany.showCompletedActivities',
  'dialogs.viewCompany.showRejectedActivities',
  'dialogs.viewCompany.showAllQuotingRevisions',
  'dialogs.viewCompany.showPostedInvoices',
  'dialogs.viewJobCard.isJobTabAddressVisible',
  'dialogs.addBulkInvoices.invoicedDateOption',
  'dialogs.addItemsToPurchaseOrder.allRevisions',
  'dialogs.addItemsToPurchaseOrder.statusTypes',
  'dialogs.addItemsToPurchaseOrder.companies',
  'dialogs.addItemsToPurchaseOrder.userTypes',
  'dialogs.addItemsToPurchaseOrder.contacts',
  'dialogs.addItemsToPurchaseOrder.dateTypes',
  'dialogs.addItemsToPurchaseOrder.timeKey',
  'dialogs.addItemsToPurchaseOrder.targetStart',
  'dialogs.addItemsToPurchaseOrder.targetEnd',
  'dialogs.sendEmailDialog.isSendCopyEnabled',
  'dialogs.sendEmailDialog.quotingEmailFromName',
  'dialogs.sendEmailDialog.quotingEmailReplyTo',
  'dialogs.sendEmailDialog.purchasingEmailFromName',
  'dialogs.sendEmailDialog.purchasingEmailReplyTo',
  'dialogs.sendEmailDialog.deliveriesEmailFromName',
  'dialogs.sendEmailDialog.deliveriesEmailReplyTo',
  'dialogs.sendEmailDialog.invoicingEmailFromName',
  'dialogs.sendEmailDialog.invoicingEmailReplyTo',
  'dialogs.purchaseInvoice.defaultInvoiceCreateType',
  'quotingContext.approvals.filters',
  'quotingContext.dashboard.timeKey',
  'quotingContext.dashboard.personId',
  'quotingContext.dashboard.companyId',
  'quotingContext.quotes.showAllRevisions',
  'quotingContext.quotes.timeKey',
  'quotingContext.quotes.salesmanId',
  'quotingContext.quotes.estimatorId',
  'quotingContext.quotes.companyId',
  'quotingContext.quotes.type',
  'quotingContext.selector.type',
  'quotingContext.selector.creatorId',
  'quotingContext.selector.salesmanId',
  'quotingContext.selector.estimatorId',
  'quotingContext.selector.timeKey',
  'quotingContext.selector.allRevisions',
  'quotingContext.selector.statusTypes',
  'quotingContext.selector.companies',
  'quotingContext.selector.userTypes',
  'quotingContext.selector.contacts',
  'quotingContext.selector.dateTypes',
  'quotingContext.selector.targetStart',
  'quotingContext.selector.targetEnd',
  'quotingContext.selector.orderTypeId',
  'quotingContext.selected.activitiesTab.showCompleted',
  'quotingContext.selected.activitiesTab.showRejected',
  'quotingContext.selected.invoicesTab.showCompleted',
  'quotingContext.selected.companyId',
  'quotingContext.selected.contactId',
  'quotingContext.selected.purchasingTab.showAllRevisions',
  'invoicingContext.add.defaultInvoiceCreateType',
  'invoicingContext.invoices.companyId',
  'invoicingContext.invoices.status',
  'invoicingContext.invoices.timeKey',
  'invoicingContext.invoices.estimatorId',
  'invoicingContext.invoices.orderTypeId',
  'invoicingContext.notInvoiced.companyId',
  'invoicingContext.notInvoiced.timeKey',
  'invoicingContext.notInvoiced.dateTypes',
  'invoicingContext.notInvoiced.targetStart',
  'invoicingContext.notInvoiced.targetEnd',
  'invoicingContext.notInvoiced.estimatorId',
  'invoicingContext.notInvoiced.salesPersonId',
  'invoicingContext.notInvoiced.selectedRoles',
  'invoicingContext.notInvoiced.selectedContacts',
  'invoicingContext.notInvoiced.orderTypeId',
  'invoicingContext.notInvoiced.status',
  'invoicingContext.purchasing.status',
  'invoicingContext.purchasing.companyId',
  'invoicingContext.purchasing.timeKey',
  'invoicingContext.purchasing.targetStart',
  'invoicingContext.purchasing.targetEnd',
  'invoicingContext.purchasing.creatorId',
  'settings',
  'language.targetLanguage',
  'notifications.hidden',
  'ui.headerMinimised',
  'onboarding.skillHintDismissed',
  'diaryContext.activities.toggleCompletedActivities',
  'diaryContext.activities.toggleRejectedActivities',
  'diaryContext.activities.activityTypes',
  'diaryContext.activities.users',
  'diaryContext.activities.companies',
  'diaryContext.activities.contacts',
  'diaryContext.activities.references',
  'diaryContext.activities.activityStatuses',
  'diaryContext.activities.calendarActivityOptionsOrder',
  'diaryContext.activities.calendarActivityOptions',
  'diaryContext.activities.agendaActivityOptionsOrder',
  'diaryContext.activities.agendaActivityOptions',
  'priceListsContext.parts.priceListId',
  'priceListsContext.parts.category',
  'priceListsContext.parts.categoryId',
  'priceListsContext.parts.parentCategoryIds',
  'priceListsContext.parts.showDormants',
  'priceListsContext.parts.search',
  'priceListsContext.partCategoryDetailsExpanded',
  'priceListsContext.suppliersOpen',
  'pricingCalculator.includeDormantResources',
  'productionContext.jobBoards.filters',
  'productionContext.jobBoards.isJobCardViewMaximised',
  'productionContext.jobBoards.expandedWorkCentres',
  'productionContext.jobBoards.jobCardListView.statusTypes',
  'productionContext.jobBoards.jobCardListView.companies',
  'productionContext.jobBoards.jobCardListView.orderTypeId',
  'productionContext.jobBoards.jobCardListView.selectedDepartments',
  'productionContext.jobBoards.jobCardListView.selectedWorkCentres',
  'productionContext.jobBoards.jobCardListView.selectedRoles',
  'productionContext.jobBoards.jobCardListView.selectedContacts',
  'productionContext.jobBoards.jobCardListView.dateTypes',
  'productionContext.jobBoards.jobCardListView.timeKey',
  'purchasingContext.purchaseOrders.status',
  'purchasingContext.purchaseOrders.companies',
  'purchasingContext.purchaseOrders.raisedBy',
  'purchasingContext.purchaseOrders.printedEmailed',
  'purchasingContext.purchaseOrders.dateTypes',
  'purchasingContext.purchaseOrders.timeKey',
  'purchasingContext.purchaseOrders.targetStart',
  'purchasingContext.purchaseOrders.targetEnd',
  'purchasingContext.selector.creatorId',
  'purchasingContext.selector.timeKey',
  'purchasingContext.selector.selectedOrderId',
  'purchasingContext.selector.showLineItems',
  'purchasingContext.selector.statusTypes',
  'purchasingContext.selector.companies',
  'purchasingContext.selector.contacts',
  'purchasingContext.selector.dateTypes',
  'purchasingContext.selector.targetStart',
  'purchasingContext.selector.targetEnd',
  'purchasingContext.selected.companyId',
  'purchasingContext.selected.contactId',
  'routes.trackedRoutes',
  'salesContext.opportunitiesView.status',
  'salesContext.opportunitiesView.companies',
  'salesContext.opportunitiesView.users',
  'salesContext.opportunitiesView.stages',
  'salesContext.opportunitiesView.jobTypes',
  'salesContext.opportunitiesView.dateTypes',
  'salesContext.opportunitiesView.timeKey',
  'salesContext.opportunitiesView.targetStart',
  'salesContext.opportunitiesView.targetEnd',
  'salesContext.leadsView.company',
  'salesContext.leadsView.createdStart',
  'salesContext.leadsView.createdEnd',
  'salesContext.leadsView.createdTimeKey',
  'salesContext.sellingView.company',
  'salesContext.sellingView.expectedStart',
  'salesContext.sellingView.expectedEnd',
  'salesContext.sellingView.expectedTimeKey',
  'salesContext.sellingView.nextActivityStart',
  'salesContext.sellingView.nextActivityEnd',
  'salesContext.sellingView.nextActivityTimeKey',
  'salesContext.wonView.company',
  'salesContext.wonView.wonStart',
  'salesContext.wonView.wonEnd',
  'salesContext.wonView.wonTimeKey',
  'salesContext.successStats.createdStart',
  'salesContext.successStats.createdEnd',
  'salesContext.successStats.createdTimeKey',
  'salesContext.successStats.visibleLeads',
  'salesContext.successStats.visibleSelling',
  'salesContext.successStats.visibleWon',
  'salesContext.successStats.stageModifiedStart',
  'salesContext.successStats.stageModifiedEnd',
  'salesContext.successStats.stageModifiedTimeKey',
  'salesContext.userOrTeam',
  'salesContext.jobTypes',
  'salesContext.showDormants',
  'salesContext.salesAnalysisView.quoteDataSource.layoutId',
  'salesContext.salesAnalysisView.invoiceDataSource.layoutId',
  'salesContext.salesAnalysisView.dataSource',
  'settingsContext.teams.showDormants',
  'settingsContext.printTemplateEditor.order',
  'settingsContext.printTemplateEditor.purchaseOrder',
  'settingsContext.printTemplateEditor.deliveryNote',
  'settingsContext.printTemplateEditor.invoice',
  'settingsContext.printTemplateEditor.selectedQuotePrintTemplateGroupId',
  'settingsContext.printTemplateEditor.selectedPurchasePrintTemplateGroupId',
  'settingsContext.printTemplateEditor.selectedDeliveryPrintTemplateGroupId',
  'settingsContext.printTemplateEditor.selectedInvoicesPrintTemplateGroupId',
  // WARNING! Ensure that portions of the state added here are LIGHT
  // and do NOT contain any data loaded from the server !!!
]

// add pivot table locations
const pivotTableLocations = [
  'quotingContext.selected.itemDrawer.subItems',
  activitiesTabPivotTableKey,
  addItemsToPurchaseOrderDialogChosenItemsPivotTableKey,
  addItemsToPurchaseOrderDialogItemsPivotTableKey,
  addItemsToPurchaseOrderDialogOrdersPivotTableKey,
  contactsContextActivitiesTabPivotTableKey,
  contactsContextCompanyContactsPivotTableKey,
  contactsContextDocumentsTabPivotTableKey,
  contactsContextGridPivotTableKey,
  contactsContextOpportunitiesTabPivotTableKey,
  contactsContextQuotesTabPivotTableKey,
  contactsContextsInvoicesTabPivotTableKey,
  contactsSearchPivotTableKey,
  deliveredNotInvoicedPivotTableKey,
  deliveriesQuoteSelectorPivotTableKey,
  deliveryNotesPivotTableKey,
  diaryContextActivitiesPivotTable,
  invoiceItemsPivotTableKey,
  invoicesTabPivotTableKey,
  invoicingContextInvoicesPivotTableKey,
  invoicingContextReceivedNotInvoicedPivotTableKey,
  itemPivotTableKey,
  jobCardOrderItemsPivotTableKey,
  listBuilderContactsPivotTableKey,
  opportunityDialogActivitiesPivotTableKey,
  opportunityDialogQuotesPivotTableKey,
  partsPivotTableKey,
  purchaseOrderItemsPivotTableKey,
  purchaseOrdersPivotTableKey,
  purchasingContextPurchaseInvoiceItemsPivotTableKey,
  purchasingContextSelectorOrderItemsPivotTableKey,
  purchasingContextSelectorOrdersPivotTableKey,
  quotingContextApprovalsPivotTableKey,
  quotingContextBillOfLabourPivotTableKey,
  quotingContextBillOfMaterialsPivotTableKey,
  quotingContextDocumentsPivotTableKey,
  quotingContextQuoteApprovalsPivotTableKey,
  quotingContextQuotePivotTableKey,
  quotingContextSelectorOrderItemsPivotTableKey,
  quotingContextSelectorOrdersPivotTableKey,
  readyForDeliveryQuotesPivotTableKey,
  salesContextOpportunitiesPivotTableKey,
  viewCompanyActivitiesPivotTableKey,
  viewCompanyInvoicesPivotTableKey,
  viewCompanyQuotesPivotTableKey,
  jobCardListViewPivotTableKey,
]

// add pivot table keys to be saved
const pivotTableKeys = [
  'sortColumn',
  'sortDirection',
  'columns',
  'columnSizes',
  'groups',
  'gridStretch',
  'pageSize',
]

const panelLocations = [
  'quotingContext.dashboard.draftQuotes',
  'quotingContext.dashboard.quotedQuotes',
  'quotingContext.dashboard.paidQuotes',
  'quotingContext.dashboard.rejectedQuotes',
  'quotingContext.dashboard.creditedQuotes',
  'quotingContext.dashboard.confirmedQuotes',
  'quotingContext.dashboard.deliveredQuotes',
  'quotingContext.dashboard.invoicedQuotes',
  'quotingContext.dashboard.draQuotes',
  'quotingContext.dashboard.draftQuotes',
  'quotingContext.dashboard.recentPanel',
  'quotingContext.dashboard.unsentPanel',
  'quotingContext.dashboard.unconfirmedPanel',
  'quotingContext.dashboard.notAcceptedPanel',
  'quotingContext.dashboard.expiringPanel',
  'quotingContext.dashboard.expiredPanel',
  'quotingContext.dashboard.inProductionPanel',
  'quotingContext.dashboard.requiredSoonPanel',
  'quotingContext.dashboard.inDeliveryPanel',
]

const panelKeys = [
  'open',
  'active',
]

const onboardingSkillLocations = Object.values(SKILLS).map(skill => `onboarding.skills.${skill.key}`)
const onboardingSkillKeys = [
  'started',
  'completed',
]

const getKeys = (path, keys) => {
  return keys.map(key => `${path}.${key}`)
}

const getKeyedState = (state, locations, keys) => {
  return flattenDeep(locations.map(location => getKeys(location, keys)))
}

const resourceTableLocations = (state) =>
  Object.keys(get(state, 'pricingCalculator.resourceTables', {}))
    .map(typeName => `pricingCalculator.resourceTables.${typeName}`)

//Must return an array of object paths
export default (state) => {
  return [
    ...staticLocations,
    ...getKeyedState(state, resourceTableLocations(state), pivotTableKeys),
    ...getKeyedState(state, pivotTableLocations, pivotTableKeys),
    ...getKeyedState(state, panelLocations, panelKeys),
    ...getKeyedState(state, onboardingSkillLocations, onboardingSkillKeys),
  ]
}
